import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35 2.625H4.025C3.53495 2.625 3.28993 2.625 3.10276 2.72037C2.93812 2.80426 2.80426 2.93812 2.72037 3.10276C2.625 3.28993 2.625 3.53495 2.625 4.025V7.35C2.625 7.84005 2.625 8.08507 2.72037 8.27224C2.80426 8.43688 2.93812 8.57074 3.10276 8.65463C3.28993 8.75 3.53495 8.75 4.025 8.75H7.35C7.84005 8.75 8.08507 8.75 8.27224 8.65463C8.43688 8.57074 8.57074 8.43688 8.65463 8.27224C8.75 8.08507 8.75 7.84005 8.75 7.35V4.025C8.75 3.53495 8.75 3.28993 8.65463 3.10276C8.57074 2.93812 8.43688 2.80426 8.27224 2.72037C8.08507 2.625 7.84005 2.625 7.35 2.625Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.975 2.625H13.65C13.16 2.625 12.9149 2.625 12.7278 2.72037C12.5631 2.80426 12.4293 2.93812 12.3454 3.10276C12.25 3.28993 12.25 3.53495 12.25 4.025V7.35C12.25 7.84005 12.25 8.08507 12.3454 8.27224C12.4293 8.43688 12.5631 8.57074 12.7278 8.65463C12.9149 8.75 13.16 8.75 13.65 8.75H16.975C17.465 8.75 17.7101 8.75 17.8972 8.65463C18.0619 8.57074 18.1957 8.43688 18.2796 8.27224C18.375 8.08507 18.375 7.84005 18.375 7.35V4.025C18.375 3.53495 18.375 3.28993 18.2796 3.10276C18.1957 2.93812 18.0619 2.80426 17.8972 2.72037C17.7101 2.625 17.465 2.625 16.975 2.625Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.975 12.25H13.65C13.16 12.25 12.9149 12.25 12.7278 12.3454C12.5631 12.4293 12.4293 12.5631 12.3454 12.7278C12.25 12.9149 12.25 13.16 12.25 13.65V16.975C12.25 17.465 12.25 17.7101 12.3454 17.8972C12.4293 18.0619 12.5631 18.1957 12.7278 18.2796C12.9149 18.375 13.16 18.375 13.65 18.375H16.975C17.465 18.375 17.7101 18.375 17.8972 18.2796C18.0619 18.1957 18.1957 18.0619 18.2796 17.8972C18.375 17.7101 18.375 17.465 18.375 16.975V13.65C18.375 13.16 18.375 12.9149 18.2796 12.7278C18.1957 12.5631 18.0619 12.4293 17.8972 12.3454C17.7101 12.25 17.465 12.25 16.975 12.25Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35 12.25H4.025C3.53495 12.25 3.28993 12.25 3.10276 12.3454C2.93812 12.4293 2.80426 12.5631 2.72037 12.7278C2.625 12.9149 2.625 13.16 2.625 13.65V16.975C2.625 17.465 2.625 17.7101 2.72037 17.8972C2.80426 18.0619 2.93812 18.1957 3.10276 18.2796C3.28993 18.375 3.53495 18.375 4.025 18.375H7.35C7.84005 18.375 8.08507 18.375 8.27224 18.2796C8.43688 18.1957 8.57074 18.0619 8.65463 17.8972C8.75 17.7101 8.75 17.465 8.75 16.975V13.65C8.75 13.16 8.75 12.9149 8.65463 12.7278C8.57074 12.5631 8.43688 12.4293 8.27224 12.3454C8.08507 12.25 7.84005 12.25 7.35 12.25Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDashboard;
